import { Speaker, Reason, Stat, Event, NavItem, CoreTeamMember } from '../types';

export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const navItems: NavItem[] = [
  { id: 'home', label: 'Home', href: '/' },

  { id: 'about', label: 'About', href: '/about' },
  // { id: 'speakers', label: 'Speakers', href: '/speakers' },
  { id: 'events', label: 'Events', href: '/events' },
  // { id: 'our-team', label: 'Our Team', href: '/our-team' },
  // { id: 'gallery', label: 'Gallery', href: '/gallery' },
  // { id: 'blog', label: 'Blog', href: '/blog' },
  { id: 'our-initiatives', label: 'Our Initiatives', href: '/our-initiatives' },

  // { id: 'sponsors', label: 'Sponsors', href: '/sponsors' },           
 { id: 'bengaluru-dreamin-2025', label: 'Bengaluru Dreamin 2024', href: '/BengaluruDreamin2025' },
  
   { id: 'copadocon2025', label: 'CopadoCon 2025', href: '/copadocon2025' },
    { id: 'contact', label: 'Contact Us', href: '/contact-us' }
];

export const speakers: Speaker[] = [
  {
    id: 'nalini-sharma',
    name: "Nalini Sharma",
    topic: "Driving Salesforce Adoption in Large Enterprises",
    experience: "24 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-06-24'
  },
   {
    id: 'nalini-sharma',
    name: "Nalini Sharma",
    topic: "Driving Salesforce Adoption in Large Enterprises",
    experience: "24 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-06-24'
  }, {
    id: 'nalini-sharma',
    name: "Nalini Sharma",
    topic: "Driving Salesforce Adoption in Large Enterprises",
    experience: "24 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-06-24'
  },
  {
    id: 'shibu-mathew',
    name: "Shibu Mathew",
    topic: "Salesforce Best Practices and Tips",
    experience: "17 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-10-28'
  },
  {
    id: 'kannan-narayanan',
    name: "Kannan Narayanan",
    topic: "Advanced Salesforce Architectures",
    experience: "11 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2024-02-10'
  },
  {
    id: 'roshan-dsouza',
    name: "Roshan D'Souza",
    topic: "Building a Career in Salesforce",
    experience: "10 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-07-22'
  },
{
    id: 'nalini-sharma',
    name: "Nalini Sharma",
    topic: "Driving Salesforce Adoption in Large Enterprises",
    experience: "24 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-06-24'
  },
  {
    id: 'shibu-mathew',
    name: "Shibu Mathew",
    topic: "Salesforce Best Practices and Tips",
    experience: "17 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-10-28'
  },
  {
    id: 'kannan-narayanan',
    name: "Kannan Narayanan",
    topic: "Advanced Salesforce Architectures",
    experience: "11 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2024-02-10'
  },
  {
    id: 'roshan-dsouza',
    name: "Roshan D'Souza",
    topic: "Building a Career in Salesforce",
    experience: "10 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-07-22'
  },
  {
    id: 'nalini-sharma',
    name: "Nalini Sharma",
    topic: "Driving Salesforce Adoption in Large Enterprises",
    experience: "24 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-06-24'
  },
  {
    id: 'shibu-mathew',
    name: "Shibu Mathew",
    topic: "Salesforce Best Practices and Tips",
    experience: "17 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-10-28'
  },
  {
    id: 'kannan-narayanan',
    name: "Kannan Narayanan",
    topic: "Advanced Salesforce Architectures",
    experience: "11 years",
    image:'/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2024-02-10'
  },
  {
    id: 'roshan-dsouza',
    name: "Roshan D'Souza",
    topic: "Building a Career in Salesforce",
    experience: "10 years",
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    dateSpoken: '2023-07-22'
  },

];

export const reasons: Reason[] = [
  {
    id: 'networking',
    title: "Greatest Minds Together",
    description: "Network with the most brilliant minds in the Salesforce community under one roof",
    icon: 'users'
  },
  {
    id: 'learning',
    title: "Learn from the Best",
    description: "Speakers with the greatest minds and ideas will share their knowledge and expertise",
    icon: 'award'
  },
  {
    id: 'social-impact',
    title: "Social Impact",
    description: "Join hands with us in focusing on various social movements and community initiatives",
    icon: 'heart'
  },
  {
    id: 'after-party',
    title: "Unforgettable After Party",
    description: "Experience a wonderful after party that you absolutely wouldn't want to miss",
    icon: 'star'
  }
];

export const stats: Stat[] = [
  { id: 'attendees', number: "650+", label: "Attendees (Post-COVID)" },
  { id: 'trailblazers', number: "80+", label: "Trailblazers" },
  { id: 'students', number: "600+", label: "Students Reached" },
  { id: 'experience', number: "24", label: "Years Experience" }
];

export const coreTeam: CoreTeamMember[] = [
  {
    id: 'sudeer-kamat',
    name: 'Sudeer Kamat',
    role: 'Creativity & Alignment Head',
    image: '/images/coreteamandfounders/Sudeer-1-2.png',
    bio: [
      'Lead Software Engineer with 8x Salesforce certifications.',
      'Co-Leading the Company Wide Salesforce Developer Group',
      'Mentor at Trailblazer Mentorship Program.',
      'Loves sharing new Salesforce Updates on Social Media, Also a Design Lover.'
    ],
    linkedin: 'https://www.linkedin.com/in/sudeerkamat/',
    x: ''
  },
  {
    id: 'Harshit Sharma',
    name: 'Harshit Sharma',
    role: 'Social Media & Finance Head',
    image: '/images/coreteamandfounders/Harshit-2.png',
    bio: [
      'Harshit is a 5x certified Salesforce developer currently working at UST. Beyond his technical prowess, Harshit embodies an entrepreneurial spirit, fueled by his passion for startups and innovation. He is a storyteller at heart, with a knack for crafting compelling content on LinkedIn and penning insightful blogs on Salesforce technology.'
    ],
    linkedin: 'https://www.linkedin.com/in/sharmaharshit/',
    x: ''
  },
  {
    id: 'Vigneshwaran Shanmugam',
    name: 'Vigneshwaran Shanmugam',
    role: 'Event Management Head',
    image: '/images/coreteamandfounders/Vignesh-scaled.jpg',
    bio: [
      'Technical product manager with a versatile background in multiple industry verticals, specializing in B2B enterprise businesses. Proficient in successfully launching diverse products within the Salesforce B2B marketplace(AppExchange).',
      'He loves to build teams that innovate and create digital products that can scale and thrive.',
      'He currently works at Arcadia, which is on a mission against the global climate crisis.',
    ],
    linkedin: 'https://www.linkedin.com/in/vigneshwaran-shanmugam/',
    x: ''
  },
  {
    id: 'Sudharsan C V',
    name: 'Sudharsan C V',
    role: 'Design Head',
    image: '/images/coreteamandfounders/Sudharsan.jpg',
    bio: [
      'Sudharsan C V is a Salesforce Consultant with 6x Salesforce Certifications. I enjoy adding value to the significant three stages of building a project: Definition, Development, and deployment. As an active member of Salesforce Bengaluru community I love to design posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sudharsan-c%F0%9F%8C%A7-827950170/',
    x: ''
  },
  
  {
    id: 'Chaitra C S',
    name: 'Chaitra C S',
    role: 'J2S & Students Training Head',
    image: '/images/coreteamandfounders/IMG_20230923_094227.jpg',
    bio: [
      'Salesforce Developer with expertise in Lightning Web Components',
      'Active member of Bengaluru Salesforce Developer Group',
      'Passionate about creating engaging social media content',
      'Manages financial planning and budgeting for community events'
    ],
    linkedin: 'https://www.linkedin.com/in/chaitra-c-s-064246193/',
    x: ''
  },
  {
    id: 'Chinna Babu Juturi',
    name: 'Chinna Babu Juturi',
    role: 'Website Building Head',
    image: '/images/coreteamandfounders/chinna.jpg',
    bio: [
      'Chinna Babu Juturi is a Salesforce Business Analyst with 3X certified',
      'I enjoy researching, analysing in work and motivating others to build their career in Salesforce, other than that I like Outing with Family or Friends and explore Food and Places.',
      'An active community group leader for Salesforce Vijayawada Admin group.',
                       
    ],
    linkedin: 'https://www.linkedin.com/in/chinna-babu-juturi/',
    x: ''
  },
  {
    id: 'Kumarswami Mathapati',
    name: 'Kumarswami Mathapati',
    role: 'Technology Enablement Head',
    image: '/images/coreteamandfounders/kumar.jpg',
    bio: [
      'Kumaraswami Mathapati is a Technical Lead at InfoBeans CloudTech Limited Pune, specializing in Salesforce Revenue cloud implementation. He is a prominent figure in the tech community, serving as a Salesforce Admin Group Leader in Pune and a speaker at Dev Days23. Kumaraswami is also a dedicated YouTuber(Channel: Salesforce Enthusiast), sharing his passion for Salesforce, and actively mentors through community groups and as a Pune J2S mentor. Additionally, he takes pride in his agricultural background.'
    ],
    linkedin: 'https://www.linkedin.com/in/kumarswami-mathapati/',
    x: ''
  },

  
   {
    id: 'Aishwarya Prakash',
    name: 'Aishwarya Prakash',
    role: 'Volunteers & Working Professionals Training Head',
    image: '/images/coreteamandfounders/Aish-scaled.jpg',
    bio: [
      'Salesforce SMTS at Athenahealth with 7x Salesforce and ServiceMax Certifications.',
      'Created impact in many women who took a career break by teaching them the Salesforce and helped them to get hired into Salesforce ecosystem.',
      'Passionate about mentoring and enabling individuals interested in Salesforce, including students and professionals, to be part of the ecosystem.'
    ],
    linkedin: 'https://www.linkedin.com/in/aishwaryaprak/',
    x: ''
  },
   {
    id: 'Bolabandi Rahul',
    name: 'Bolabandi Rahul',
    role: 'Media & Photography Head',
    image: '/images/coreteamandfounders/rahul.jpg',
    bio: [
      'Rahul is a Student of Cambridge Institute of Technology who is also extremely proficient in Photography and Cinematography. Capable of capturing any moment magically and tell stories through it in Silence.',
      'He also have been working tirelessly and closely with Salesforce Bengaluru Community since last year and have been part of multiple events and has been an integral part of the community in making the events successful.',
      'He has been pivotal in capturing community events and narrating the events through moving pictures more eelegantly than the words could possibly do.'
    ],
    linkedin: 'https://www.linkedin.com/in/bolabandi-rahul/',
    x: ''
  },
  {
    id: 'sukesh-koppineedi',
    name: 'Sukesh Koppineedi',
    role: 'Marketing & Procurement Head',
    image: '/images/coreteamandfounders/Sukesh-1-1.jpg',
    bio: [
      'Senior Software Engineer with 8x Salesforce-certified, 1x Salesforce Accredited Certified, 1x MuleSoft Certified, 1x Copado Certified, and All Star Ranger in Trailhead.',
      'J2S Success Story, J2S Brand Ambassador and featured in the Salesforce Developers Blog - "Journey to Salesforce Goes Global."',
      'I\'m an extrovert, always excited and enthusiastic about helping fellow trailblazers in the Salesforce community.',
      'Actively engaged on all major Social Media Platforms. Passionate about watching and playing Cricket and Badminton.'
    ],
    linkedin: 'https://www.linkedin.com/in/sukesh-koppineedi-225612120/',
    x: ''
  },
  {
    id: 'Veda',
    name: 'Veda',
    role: 'Customer Relations Head',
    image: '/images/coreteamandfounders/veda.jpeg',
    bio: [
      'I\'m a senior Salesforce consultant, 5x certification, Salesforce admin group leader.. active in Salesforce community from past 9 years.. Proud mother currently enjoying my motherhood journey along with trying to balance work + home +. My passion to contribute to Salesforce eco system',
    ],
    linkedin: 'https://www.linkedin.com/in/veda-hebbar/',
    x: ''
  },
  
  
];

export const events: Event[] = [
  {
    id: 'dec-17-2022',
    date: '2022-12-17',
    title: "Integrating Salesforce Orgs without Code",
    description: "The Salesforce Session along with 80+ trailblazers",
    attendees: "80+",
    type: 'workshop'
  },
  {
    id: 'feb-11-2023',
    date: '2023-02-11',
    title: "Open AI and chatGPT in salesforce",
    description: "Salesforce session along with 60+ trailblazers",
    attendees: "60+",
    type: 'workshop'
  },
  {
    id: 'jun-24-2023',
    date: '2023-06-24',
    title: "Bengaluru Mega Meetup",
    description: "The biggest in-person event in India Post Covid conducted with 650+ attendees",
    attendees: "650+",
    type: 'meetup'
  },
  {
    id: 'jul-22-2023',
    date: '2023-07-22',
    title: "AI Event in a Box - Generative AI for Admins",
    description: "The Salesforce Session with 120+ trailblazers",
    attendees: "120+",
    type: 'workshop'
  },
  {
    id: 'aug-12-2023',
    date: '2023-08-12',
    title: "Salesforce workshop at Cambridge Institute",
    description: "Workshop at Cambridge Institute along with 600+ students",
    attendees: "600+",
    type: 'workshop'
  },
  {
    id: 'sep-02-2023',
    date: '2023-09-02',
    title: "Salesforce workshop at East Point College",
    description: "Workshop at East Point College along with 200+ students",
    attendees: "200+",
    type: 'workshop'
  },
  {
    id: 'sep-09-2023',
    date: '2023-09-09',
    title: "Salesforce workshop at Ramaiah Institute",
    description: "Workshop at Ramaiah Institute along with 200+ students",
    attendees: "200+",
    type: 'workshop'
  },
  {
    id: 'sep-23-2023',
    date: '2023-09-23',
    title: "Salesforce workshop at ACS College",
    description: "Workshop at ACS College along with 400+ students",
    attendees: "400+",
    type: 'workshop'
  },
  {
    id: 'oct-28-2023',
    date: '2023-10-28',
    title: "Bengaluru Ohana Gathering",
    description: "Salesforce Event along with 250+ trailblazers",
    attendees: "250+",
    type: 'meetup'
  },
  {
    id: 'nov-25-2023',
    date: '2023-11-25',
    title: "Salesforce Workshop at Sambhram Institute",
    description: "Workshop at Sambhram Institute along with 300+ students",
    attendees: "300+",
    type: 'workshop'
  },
  {
    id: 'feb-10-2024',
    date: '2024-02-10',
    title: "Bengaluru Ohana Meetup",
    description: "Salesforce Session along with 150+ trailblazers",
    attendees: "150+",
    type: 'meetup'
  },
  {
    id: 'feb-24-2024',
    date: '2024-02-24',
    title: "Salesforce Workshop at New Horizon Management Studies",
    description: "Workshop at New Horizon Management Studies along with 150+ students",
    attendees: "150+",
    type: 'workshop'
  }
];

export const eventFounders = [
  {
    name: 'Akshay Vasu',
    title: 'Co-Founder & Speaker Relations Head',
    image: '/images/coreteamandfounders/Akshay-1-scaled.jpg',
    bio: [
      'Salesforce Senior Developer at Anteriad with 4x Salesforce Certifications.',
      'Leading the Bengaluru Salesforce User Group, mentor for J2S.',
      'Loves giving back to the community, telling stories, Creating Content in Social Media Platforms, writing poems in Kannada and English. Also, enjoys reading books.'
    ],
    linkedin: 'https://in.linkedin.com/in/akshay-vasu',
    x: ''
  },
  {
    name: 'Seshagiri Thamalalla',
    title: 'Co-Founder & Partner Relations Head',
    image: '/images/coreteamandfounders/Sesha-bro-dp.jpg',
    bio: [
      'Salesforce Product Specialist at Cloudbyz with 7x Salesforce Certified.',
      'Currently leading Bengaluru Admin Group and also a Speaker & Mentor for J2S program.',
      'Passionate in teaching Salesforce to college students and college professionals. Loves consulting businesses for free as he believes a country will grow by great talent and quality businesses.'
    ],
    linkedin: 'https://www.linkedin.com/in/thamalalla',
    x: ''
  },
  {
    name: 'Rupalika Sahoo',
    title: 'Co-Founder & Salesforce Relations Head',
    image: '/images/coreteamandfounders/Rupalika-1-1.jpg',
    bio: [
      'Salesforce Senior Consultant at one of the Big4 with 14x Salesforce Certified Developer.',
      'Leading Bengaluru Women In Tech Group, mentor for J2S.',
      'Believes in giving back to the community. Loves to travel and mountains are her calling. Enjoys doing art and crafts.'
    ],
    linkedin: 'https://www.linkedin.com/in/rupalika-sahoo-831663107',
    x: ''
  }
];

export const advisoryTeam = [
  {
    name: 'Nalini Krishnan',
    title: 'Head - Sourcing, Competency & Governance - Salesforce Practice, TCS',
    image: '/images/coreteamandfounders/Nalini-Mam.jpeg',
    bio: [
      "With an impressive career spanning 24 years, Nalini currently holds the esteemed position of Head of Sourcing, Competency, and Governance - Salesforce Practice at TCS. Her journey is a testament to her unwavering dedication, unparalleled expertise and visionary leadership in nurturing talent within the tech community.",
      "Nalini's deep-rooted passion for community-led initiatives is well known, having played instrumental roles in various impactful endeavours. Her commitment to mentoring and uplifting the next generation of Salesforce enthusiasts has left an indelible mark, shaping the future trajectory of our ecosystem."
    ],
    linkedin: 'https://www.linkedin.com/in/nalinik/',
    x: ''
  },
  {
    name: 'Shibu Abraham',
    title: 'Salesforce MVP, APAC Head - Salesforce Practice, UST',
    image: '/images/coreteamandfounders/SAGH.png',
    bio: [
      "Shibu, a Salesforce MVP, Marketing Champion and Golden Hoodie recipient, brings a wealth of experience and leadership to our team. With an impressive 17-year journey in the Salesforce ecosystem, Shibu currently heads the APAC Salesforce Practice at UST.",
      "Beyond his remarkable achievements, what truly sets Shibu apart is his unwavering commitment to empowering others. He generously shares his expertise through blogs, videos, webinars and user group sessions, constantly inspiring our community to learn and grow together.",
      "Shibu's extensive experience collaborating with customers and partners on diverse Salesforce implementation initiatives speaks volumes about his expertise and passion for driving meaningful impact."
    ],
    linkedin: 'https://www.linkedin.com/in/shibua/',
    x: ''
  },
  {
    name: 'Kannan Narayanan',
    title: 'Salesforce MVP & Unit Technology Officer ( CTO of Salesforce Practice), Infosys',
    image: '/images/coreteamandfounders/WhatsApp-Image-2024-03-16-at-11.46.28-AM.jpeg',
    bio: [
      "Kannan brings a wealth of experience, boasting over 11 years of invaluable contributions to the Salesforce community. As a Salesforce MVP and a seasoned Practitioner, he is not just a leader but a true trailblazer with over 50 Salesforce credentials under his belt.",
      "From providing top-notch advisory architectural services to spearheading solution delivery excellence, Kannan has spearheaded the end-to-end journey of five AppExchange listings, from conceptualization to fully-fledged solutions.",
      "But Kannan's impact extends far beyond the boardroom. As a dedicated volunteer at the NASSCOM Industry Mentoring Program and a Trailblazer Community Leader, he's shaping the next generation of tech enthusiasts and architects.",
      "Within his current role, Kannan heads the CoE - Architecture practice and Technology Consulting Group, where he's led the delivery of over 300 tools, accelerators, and reusable assets for the Salesforce practice. His commitment to nurturing talent is unmatched, having mentored and enabled practitioners with countless certifications and accreditations."
    ],
    linkedin: 'https://www.linkedin.com/in/kannan-narayanan-architect/',
    x: ''
  },
  {
    name: 'Roshan K',
    title: 'Founder & Host - The Salesforce Club',
    image: '/images/coreteamandfounders/JPEG-image.jpeg',
    bio: [
      "He is the founder and CEO of Altokk Software Solutions and also hosts insightful conversations at The Salesforce Club",
      "With over a decade of experience in the Salesforce ecosystem, Roshan brings a wealth of expertise and passion to our team.",
      "He is an active member and leader within the Salesforce Trailblazer Community, you'll often find Roshan at in-person events, whether as a Host, speaker, panelist or enthusiastic attendee!",
      "With the privilege of working with both Enterprise and SMB customers, Roshan has played diverse roles across various projects, including Developer, Analyst, Tech Lead, Scrum Master and more.",
      "Career counselling holds a special place in Roshan's heart, offering guidance on building sustainable careers within the Salesforce ecosystem."
    ],
    linkedin: 'https://www.linkedin.com/in/roshankotla/',
    x: ''
  }
];